import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'

import Spinner from '~/components/Spinner'

import { useProductHeaderProvider } from '~/providers/ProductPageProvider'
import { useTheme } from '~/providers/ThemeProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type PreviewLoaderProps = {
  className?: string
}

export function PreviewLoader({ className }: PreviewLoaderProps) {
  const { isLoadingPreviewImages: isLoading } = useProductHeaderProvider()
  const { colors } = useTheme()

  if (!isLoading) return null
  return (
    <div className={cx(css.PreviewLoader, className)}>
      <Spinner
        className={cx(css.loader)}
        theme={colors[GlobalThemeColors.Blue]}
      />
    </div>
  )
}
